import { render, staticRenderFns } from "./ReportTransferences.vue?vue&type=template&id=bf003e60"
import script from "./ReportTransferences.vue?vue&type=script&lang=js"
export * from "./ReportTransferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports